// src/hooks/usePermissions.js
import { useEffect, useState } from 'react';
import {
  getPermissions,
  setPermission,
} from '../services/collabService';
import { permissionsToRole, roleToPermissions } from '../utils/roleMapper'


export default function usePermissions(recipeId) {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!recipeId) return;
    let ignore = false;
    setLoading(true);

    getPermissions(recipeId)
      .then((res) => {
        if (!ignore) 
          setTeam(
            res.data.map(({ email, ...perms }) => ({
              email,
              role: permissionsToRole(perms),
            }))
          );
      })
      .catch(() => {
        if (!ignore) setTeam([]);
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => { ignore = true };
  }, [recipeId]);

  const addPermission = async (email, role) => {
    await setPermission(recipeId, email, roleToPermissions(role)) // 🛠️ fixed here
    setTeam((prev) => [...prev, { email, role }])
  }

  const updatePermission = async (email, role) => {
    await setPermission(recipeId, email, roleToPermissions(role)) // 🛠️ fixed here too
    setTeam((prev) =>
      prev.map((u) => (u.email === email ? { ...u, role } : u))
    )
  }

  return {
    team,
    loading,
    addPermission,
    updatePermission,
  }
}